<header class="header-main">
  <div class="d-none d-lg-block">
    <app-top-bar></app-top-bar>
  </div>
  <app-main-menu></app-main-menu>
</header>
